<template>
    <v-date-picker class="mt-0 pt-0" full-width elevation="15" v-model="dates" range></v-date-picker>
</template>


<script>

import moment from 'moment'

export default {
    data() {
        return {
            dates: [],
            startDate: new Date(),
            endDate: new Date()
        }
    },
    mounted: function () {
        this.startDate = moment().format('YYYY-MM-DD');
        this.dates.push(this.startDate);
        let today = new Date();

        today.setDate(today.getDate() + 1);
        this.endDate = moment(today).format('YYYY-MM-DD');
        this.dates.push(this.endDate);
        if (this.$route.name === 'Booking') {
            this.searchRoomRatePlan();
        }
    },
    watch: {
        dates: function () {
            if (this.dates.length === 2) {
                if (this.$route.name === 'Booking') {
                    this.searchRoomRatePlan();
                }
            }

        }
    },
    methods: {
        searchRoomRatePlan: function () {
            const model = {
                startDate: this.dates[0],
                endDate: this.dates[1],
            };
            this.$store.dispatch("getRoomTypeAvailabilityAndRates", model);

            this.$store.dispatch('setActiveScreen', 'room');

            if (this.$route.name !== 'Booking') {
                this.$router.push(`/Booking/TestHotel/${this.PropertyCode}`);
            }
            if (this.firstLoad)
                this.firstLoad = false;


        },
    }
}
</script>